import {GET_GRAPH} from '../types';
import {SET_TIMEFRAME_ACTIVE} from '../types';

const initialState = {
    items: [],
    timeframes: ['5m', '15m', '30m', '1h', '2h', '4h', '6h', '8h', '12h', '1d'],
    activeTimeframe: '5m'
    // activeTimeframe: '1d'
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_GRAPH:
            return {
                ...state,
                items: action.payload,

            };
        case SET_TIMEFRAME_ACTIVE:
            return {
                ...state,
                activeTimeframe: action.payload,
            };
        default:
            return state;
    }

}
